import { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { Loader2, Forward } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Checkbox } from "./ui/checkbox";
import { api } from "../lib/api";
import { normSearch, personMatch } from "../lib/searchText";

export const PortalForwardDialog = ({ task, onClose, onDone }) => {
  const [emps, setEmps] = useState([]);
  const [q, setQ] = useState("");
  const [picked, setPicked] = useState([]);
  const [f, setF] = useState({ description: "", due_date: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!task) return;
    setPicked([]); setQ(""); setF({ description: "", due_date: task.due_date || "" });
    api.portalTaskAssignable().then((r) => setEmps(r.employees || [])).catch((e) => toast.error(e?.response?.data?.detail || "تعذّر تحميل الموظفين"));
  }, [task]);
  const list = useMemo(() => { return q.trim() ? emps.filter((e) => personMatch(e, q)) : emps; }, [emps, q]);
  const toggle = (id) => setPicked((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
  const send = async () => {
    if (!picked.length) { toast.error("اختر موظفاً واحداً على الأقل"); return; }
    setBusy(true);
    try {
      await api.portalForwardTask(task.id, { employee_ids: picked, description: f.description, due_date: f.due_date || null });
      toast.success("تم تحويل المهمة"); onDone?.(); onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر التحويل"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!task} onOpenChange={(v) => !v && onClose()}>
      <DialogContent dir="rtl" className="max-w-md max-h-[90vh] overflow-y-auto" data-testid="portal-forward-dialog">
        <DialogHeader className="text-right">
          <DialogTitle className="font-heading">تحويل المهمة</DialogTitle>
          <DialogDescription>«{task?.title}» — تبقى مرتبطة بالأصل، ولا تكتمل إلا بعد إنجاز المحوَّل إليهم</DialogDescription>
        </DialogHeader>
        <Textarea data-testid="portal-forward-desc" rows={2} placeholder="ملاحظة للمستلم (اختياري)" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} />
        <div className="flex items-center gap-2 text-xs"><span className="text-slate-500">الموعد</span>
          <Input type="date" data-testid="portal-forward-due" value={f.due_date} onChange={(e) => setF({ ...f, due_date: e.target.value })} className="h-9" /></div>
        <Input data-testid="portal-forward-search" placeholder="ابحث عن موظف…" value={q} onChange={(e) => setQ(e.target.value)} className="h-9" />
        <div className="max-h-56 divide-y overflow-y-auto rounded-xl border border-slate-200">
          {list.map((e) => (
            <label key={e.id} className="flex cursor-pointer items-center gap-2 p-2 text-sm hover:bg-slate-50" data-testid={`portal-forward-emp-${e.id}`}>
              <Checkbox checked={picked.includes(e.id)} onCheckedChange={() => toggle(e.id)} />
              <span className="flex-1">{e.name}</span>{e.branch && <span className="text-[10px] text-slate-400">{e.branch}</span>}
            </label>
          ))}
          {!list.length && <p className="p-3 text-center text-xs text-slate-400">لا يوجد موظفون</p>}
        </div>
        <Button data-testid="portal-forward-send" disabled={busy} onClick={send} className="w-full gap-1.5">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Forward className="h-4 w-4" />} تحويل ({picked.length})
        </Button>
      </DialogContent>
    </Dialog>
  );
};
